import { render, staticRenderFns } from "./TicketIcon.vue?vue&type=template&id=2da10ad3&"
import script from "./TicketIcon.vue?vue&type=script&lang=js&"
export * from "./TicketIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports